// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_FYn","cls2":"AuthorHeader-cls2_Sjg AuthorHeader-cls1_FYn"};